const getStickyFromTop = () => {
    const stickyElements = Array.from(
        document.querySelectorAll(".element-sticky")
    );

    const getOuterHeight = (element) => {
        const height = element.offsetHeight,
            style = window.getComputedStyle(element);

        return ["top", "bottom"]
            .map((side) => parseInt(style[`margin-${side}`]))
            .reduce((total, side) => total + side, height);
    };

    const wrapElement = (element, wrapper) => {
        wrapper.classList.add("stickyWrapper");
        wrapper.setAttribute("style", "height:fit-content");
        element.parentNode.insertBefore(wrapper, element);
        wrapper.appendChild(element);
    };

    if (stickyElements.length) {
        let totalStickyOffsetTop = 0;
        let totalScrollOffsetTop = 0;

        stickyElements.forEach((element) => {
            const elementHeight = element.clientHeight;
            const elementOffsetTop = element.offsetTop;
            const elementStickyOffsetTop = totalStickyOffsetTop;
            const elementScrollOffsetTop = totalScrollOffsetTop;
            const classSticky = "is-sticky";
            const outerHeight = getOuterHeight(element);

            wrapElement(element, document.createElement("div"), outerHeight);

            document.addEventListener("scroll", () => {
                if (
                    window.pageYOffset + elementScrollOffsetTop >
                    elementOffsetTop
                ) {
                    element.setAttribute(
                        "style",
                        "top:" + elementStickyOffsetTop + "px;"
                    );
                    element.classList.add(classSticky);
                } else {
                    element.classList.remove(classSticky);
                    element.setAttribute("style", "top:" + 0 + "px;");
                }
            });

            totalStickyOffsetTop += elementHeight;
            totalScrollOffsetTop += elementHeight;
        });
    }
};
export default getStickyFromTop;
